import { StyleProp, View, ViewStyle } from 'react-native';
import styled from 'styled-components/native';

import { translate } from '../../../i18n';
import {
  makeFreeDeliveryThreshold,
  makeSuggestCoupon,
} from '../../../redux/selectors/freeDeliverySelector';
import { useSelector } from '../../../redux/utils';
import ReachThresholdHint from '../ReachThresholdHint';

interface Props {
  style?: StyleProp<ViewStyle>;
}

export default function ReachSeriesOfHints(props: Props) {
  const freeDeliveryDiff = useSelector(makeFreeDeliveryThreshold());
  const suggestCoupon = useSelector(makeSuggestCoupon());
  const isFreeDelivery = freeDeliveryDiff <= 0;
  const isReachCouponThreshold =
    suggestCoupon.diff <= 0 && suggestCoupon.value !== 0;

  if (!isFreeDelivery) {
    return null;
  }

  return (
    <View style={props.style}>
      <ReachThresholdHint text={translate('reach-free-delivery-threshold')} />
      {isReachCouponThreshold && (
        <>
          <S.Separator />
          <ReachThresholdHint
            text={translate('reach-coupon-threshold', {
              couponAmount: suggestCoupon.value,
            })}
          />
        </>
      )}
    </View>
  );
}

const S = {
  Separator: styled.View`
    flex: 1;
    max-height: 1px;
    min-height: 1px;
    margin-bottom: 0px;
    padding: 0px;
    border-style: solid;
    border-top-width: 1px;
    border-color: ${({ theme }) => theme.palette.neutralLight};
  `,
};
